import styled from 'styled-components';

export const StyledWITBTopSection = styled.div`
  text-align: center;
  padding: 80px 0 0 0;
  display: flex;
  flex-direction: column;
  align-items: center;

  h1 {
    max-width: 1160px;
    color: var(--stile-grey-8);
    margin: 0 0 32px 0;
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;
  }

  p {
    font-weight: 400;
    font-size: 16px;
    color: var(--stile-grey-8);
    max-width: 563px;
    margin: 0 auto;
  }

  @media (max-width: 768px) {
    padding: 40px 0 0 0;

    h1 {
      margin: 0 0 25px 0;
    }

    p {
      font-size: 16px;
    }
  }
`;
